/**
 * Lightweight audit context for enriching backend audit logs.
 *
 * Usage in components:
 *   import { setAuditContext } from '@/lib/audit-context';
 *
 *   setAuditContext({ component: 'UserTable', action: 'deactivate-user' });
 *   await ssoApi.updateUser(id, { is_active: false });
 *
 * The authFetch/publicFetch functions (api.ts) read these values and
 * attach them as X-Audit-Component / X-Audit-Action headers. Values
 * auto-clear after each request so they don't leak into unrelated calls.
 */

let _component = '';
let _action = '';

/** Set audit context before triggering an API call. */
export function setAuditContext(ctx: { component?: string; action?: string }) {
  _component = ctx.component ?? '';
  _action = ctx.action ?? '';
}

/** Read and clear the current context (called by authFetch/publicFetch). */
export function consumeAuditContext(): { component: string; action: string } {
  const result = { component: _component, action: _action };
  _component = '';
  _action = '';
  return result;
}
